<template>
  <div class="content">
    <div class="content-infos">
      <Aside :title="game.title" :content="game.content" :gameName="gameName" @changeGames="changeGames" :modal="modal"/>
    </div>
    <Games :game="game" />
  </div>
</template>

<script>
import Aside from "./components/layout/Aside.vue";
import Games from "./components/layout/Games.vue";
import games from "./components/games.json";

export default {
  name: "Base",
  components: {
    Games,
    Aside
  },
  data: () => ({
    gameName: "",
    game: {},
    modal: {}
  }),
  created() {
    const queryParams = new URLSearchParams(window.location.search);

    if(queryParams.get('game') == 'coloration'){
      this.gameName = "coloration"
    } else if(queryParams.get('game') == 'tweet'){
      this.gameName = "tweet"
    } else if(queryParams.get('game') == 'morse-chappe-baudot' || queryParams.get('game') == 'morse'|| queryParams.get('game') == 'chappe' || queryParams.get('game') == 'baudot'){
      this.gameName = "chappe"
    } else {
      this.gameName = "coloration"    
    }
    this.game = games.games[this.gameName]
    this.modal = games.games[this.gameName].modal

    document.title = this.game.title
  },
  methods: {
    changeGames(event) {
      this.gameName = event.param
      this.game = games.games[this.gameName]
      this.modal = games.games[this.gameName].modal
    }
  },
};
</script>


<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}

img {
  max-width: 100%;
}

.content {
  display: flex;
  padding: 3rem;
  background-color: #fff;
  position: relative;
  min-height: 85vh;
  &-infos {
    text-align: left;
    width: 30%;
  }
  &-games {
    width: 70%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  @media (max-width: 1200px) {
    flex-direction: column;
    padding: 1rem;
    &-infos {
      width: auto;
      margin-right: 0;
    }
    &-games {
      width: auto;
      margin-left: 0;
      margin-top: 0;
    }
  }
}
.text-bold {
  font-weight: bold;
}
</style>